import Select from 'react-select'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { FormGroup, Label } from 'reactstrap'

const SelectMonth = ({ defaultValue, onChange = () => {}, value = {} }) => {
  const { t, i18n } = useTranslation('common')

  const options = useMemo(() => {
    return [
      { value: 0, label: t('month.all') },
      { value: 1, label: t('month.jan') },
      { value: 2, label: t('month.feb') },
      { value: 3, label: t('month.mar') },
      { value: 4, label: t('month.apr') },
      { value: 5, label: t('month.may') },
      { value: 6, label: t('month.jun') },
      { value: 7, label: t('month.jul') },
      { value: 8, label: t('month.aug') },
      { value: 9, label: t('month.sep') },
      { value: 10, label: t('month.oct') },
      { value: 11, label: t('month.nov') },
      { value: 12, label: t('month.dec') },
    ]
  }, [i18n.language])

  const defaultOption = options.find((v) => v.value === defaultValue)

  return (
    <FormGroup>
      <Label>{t('month.desc')}</Label>
      <Select options={options} defaultValue={defaultOption} onChange={onChange} />
    </FormGroup>
  )
}

export default SelectMonth

SelectMonth.propTypes = {
  defaultValue: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.number,
}
